import template from './navigation.jade';
import navigationCtrl from './navigation.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      segments: '=',
      category: '=',
      clearAction: '&',
    },
    controller: navigationCtrl,
    controllerAs: 'navigationCtrl',
    replace: true,
  };
};
